import React, { useEffect, useState } from "react";
import { BookOpen, Users, Video, LayoutDashboard } from "lucide-react";
import api from "../lib/api";
import PortalShell from "./PortalShell";
import TeacherStudio from "./TeacherStudio";

export default function TeacherPortal() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("overview");
  useEffect(() => { api.get("/portal/teacher/overview").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <PortalShell allow="teacher">
      <h1 className="font-display text-3xl font-bold text-[#012a1e]">Welcome, {data?.profile?.name?.split(" ")[0] || ""}</h1>
      <p className="text-slate-500 mt-1">{data?.profile?.subject ? `${data.profile.subject} · ` : ""}{data?.profile?.qualification || "Teacher portal"}</p>

      <div className="flex gap-1 bg-white border border-slate-100 rounded-full p-1 mt-5 w-fit">
        {[{ k: "overview", l: "Overview", i: LayoutDashboard }, { k: "studio", l: "Content Studio", i: BookOpen }].map((t) => (
          <button key={t.k} onClick={() => setTab(t.k)} className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-full transition-colors ${tab === t.k ? "bg-[#004030] text-white" : "text-[#004030]"}`}>
            <t.i size={16} /> {t.l}
          </button>
        ))}
      </div>

      {tab === "studio" ? (
        <div className="mt-6"><TeacherStudio /></div>
      ) : (
        <div className="grid sm:grid-cols-3 gap-4 mt-6">
          <div className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className="w-11 h-11 rounded-xl bg-[#004030] text-[#e0c05a] grid place-items-center"><BookOpen size={20} /></div>
            <p className="font-display text-3xl font-bold text-[#012a1e] mt-3">{data?.courses?.length ?? 0}</p>
            <p className="text-slate-500 text-sm">My Courses</p>
          </div>
          <div className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className="w-11 h-11 rounded-xl bg-[#c9a227] text-[#013d2b] grid place-items-center"><Users size={20} /></div>
            <p className="font-display text-3xl font-bold text-[#012a1e] mt-3">{data?.students ?? 0}</p>
            <p className="text-slate-500 text-sm">Students</p>
          </div>
          <div className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className="w-11 h-11 rounded-xl bg-[#0a5540] text-[#e0c05a] grid place-items-center"><Video size={20} /></div>
            <p className="font-display text-3xl font-bold text-[#012a1e] mt-3">0</p>
            <p className="text-slate-500 text-sm">Live Sessions</p>
          </div>
          <div className="sm:col-span-3 bg-[#004030] rounded-2xl p-6 flex items-center justify-between flex-wrap gap-4">
            <div><p className="text-white font-semibold">Build your curriculum with AI</p><p className="text-white/70 text-sm">Create video lessons and generate content with the AI builder.</p></div>
            <button onClick={() => setTab("studio")} className="bg-[#c9a227] hover:bg-[#e0c05a] text-[#013d2b] rounded-full px-6 h-11 font-bold">Open Content Studio</button>
          </div>
        </div>
      )}
    </PortalShell>
  );
}
